<mat-form-field class="dynamicForm_alignment" [formGroup]="group" [class.displayNone]="displayNoneLabportSpecCode">
  <mat-label>{{field.labelName}}</mat-label>
  <input matInput [formControlName]="field.labelCode" type="text" autocomplete="off"
        [required]="isRequired" appMaskKitId [maxlength]="maxLength" [config]="{
          arrayPos: field.hyphenPositions,
          arrayLength: field.displayFormat
        }">
    @for (validation of field.validations; track validation) {
      <ng-container ngProjectAs="mat-error">
        @if (group.get(field.labelCode).hasError(validation.name.toLocaleLowerCase()) && validation.name.toLocaleLowerCase()!==required) {
          <mat-error>{{validation.message}}</mat-error>
        }
        @if (group.get(field.labelCode).hasError(required) && validation.name.toLocaleLowerCase()===required) {
          <mat-error class="error_font">{{field.labelName}} is mandatory</mat-error>
        }
      </ng-container>
    }
    @if (group.get(field.labelCode).hasError('displayFormatError')) {
      <mat-error>Invalid format</mat-error>
    }
    @if (field.displayFormat && displayMinLengthError) {
      <mat-error>The minimum length is {{maxLength}}</mat-error>
    }
  </mat-form-field>
